import {
  REACT_APP_API_ENDPOINT,
  REACT_APP_ORGANIZATION_ID,
} from "../constants";
import { getStoredData } from "./fnAsyncStorage";
import globals from "./globals";

type Props = {
  url: string;
  method: string;
  payload?: object | undefined;
  signal?: AbortSignal | null | undefined;
  isBaseUrl?: boolean;
  jwt?: string;
};

const fetchJSON = async ({ url, method, payload, signal }: Props) => {
  const apiUrl = REACT_APP_API_ENDPOINT;
  const appOrganizationId =
    REACT_APP_ORGANIZATION_ID || globals.ORGANIZATION_ID;
  //const token = jwt;
  // console.log(apiUrl);
  const token = await getStoredData("token");
  const headers = new Headers();
  const baseUrl = `${apiUrl}/${url}`;

  headers.append("Content-Type", "application/json");
  if (appOrganizationId.length > 0) {
    headers.append("Organization", appOrganizationId);
  }

  if (token) {
    headers.append("Authorization", `Bearer ${token}`);
  }

  const res = await fetch(baseUrl, {
    method,
    headers,
    signal,
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    let message = await res.text();

    try {
      message = JSON.parse(message).message;
    } catch (e) {
      // Not JSON
    }
    throw new Error(message);
  }

  return res.json();
};

export default fetchJSON;
